import { useAnalyticsStore } from '@/store/analytics/analytics'
import { getAppMetaInfo } from '@/utils/getAppMetaInfo'

/* Composable, для передачи дефолтных метатегов в layout-ы */
export const useAppMetaInfo = () => {
  const { yandexAnalyticsProps, googleAnalyticsProps } = useAnalyticsStore()

  const yandexVerificationCode = yandexAnalyticsProps.verification
  const googleVerificationCode = googleAnalyticsProps.verification

  const meta = getAppMetaInfo({
    yandexVerification: yandexVerificationCode,
    googleVerification: googleVerificationCode,
  })

  return { meta }
}
